import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterOrdersContextMenuFillApproveItemState } from "./BfxBlotterOrdersContextMenuFillApproveItemState";
import { AbsBaseBfxBlotterOrdersContextFillMenuItem } from "./AbsBaseBfxBlotterOrdersContextFillMenuItem";

export class BfxBlotterOrdersContextMenuFillApproveItem extends AbsBaseBfxBlotterOrdersContextFillMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_DI_FILL_APPROVE,
      "Accept Fill",
      BfxBlotterOrdersContextMenuFillApproveItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuFillApproveItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.MenuItem,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuFillApproveItemState();
    this.state.title = oldState.title;
  }

  /**
   * these menu items are not visible uless you can use em.
   * https://www.bcdfx.com/ijira/browse/OMS-34568
   */
  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item: CubiqTS.OrderDataImpl,
    ) {
      AbsBaseBfxBlotterOrdersContextFillMenuItem.testIfMenuAvailable(
        null == menuState ? false : menuState.canDIApproveFill || menuState.canAcceptUnrestricted,
        menuState,
        itemState,
        item,
      );
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item: CubiqTS.OrderDataImpl,
    ) {
      AbsBaseBfxBlotterOrdersContextFillMenuItem.testIfMenuAvailable(
        null == menuState ? false : menuState.canDIApproveFill || menuState.canAcceptUnrestricted,
        menuState,
        itemState,
        item,
      );
    };
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuFillApproveItemState();
  }
}
